export default __webpack_public_path__ + "static/media/CREDIT_BEN_ROTHSTEIN_PRIME_VIDEO_00250_R3.cdad830f.jpg";